<template>
  <div>
    <WdsText xl>{{ $t(isEdit ? 'Edit custom field' : 'Add custom field') }}</WdsText>
    <div v-if="appliesToText" class="tw-flex tw-items-center">
      <div>{{ $t('Applies to:') }}&nbsp;</div>
      <strong>{{ appliesToText }}</strong>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { getAppliesToText } from '@/components/Fields/utils/CustomFieldUtils'
import { TypeSupportingCustomFieldValues } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = withDefaults(defineProps<{ 
  appliesTo: TypeSupportingCustomFieldValues,
  isEdit?: boolean
}>(), {
  isEdit: false,
})

const appliesToText = computed(() => getAppliesToText(props.appliesTo))
</script>
